import React, { useState } from "react";
import "./styles.scss";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListMembers from "../../services/list-member";
import { useDispatch } from "react-redux";
import { storeDataChart } from "../../reducer/chart-reducer";
import chartService from '../../services/chart-sevices';
import stringJp from '../../constants/stringJP';

function SubmitInfomation(props) {
    const {
        name,
        dataMember,
        dataDate,
        gender,
        index_card,
        account_id,
        setIsTypingName
    } = props;

    const dispatch = useDispatch();
    const history = useHistory();

    // const [infoMember, setInfoMember] = useState([]);
    const [double, setDouble] = useState(false);
    const [open, setOpen] = React.useState(false);

    const user = JSON.parse(localStorage.getItem("user"));
    const security_key = localStorage.getItem("security_key");
    const genderchange = localStorage.getItem("genderchange");
    const birthchange = localStorage.getItem("birthchange");
    const company_code = localStorage.getItem("company_code");
    const store_code = localStorage.getItem("store_code");
    const instore_code = localStorage.getItem("instore_code");

    const updateDatachart = () => {
        const params = {
            account_id: account_id,
            company_code: company_code,
            security_key: security_key,
            store_code: store_code,
            instore_code: instore_code,
        };
        chartService.getDataChart(params, (res) => {
            dispatch(storeDataChart({ user: { ...res.user_info } }));
        }, () => { })
    };
    /* eslint eqeqeq: 0 */
    let checkData;
    if (dataMember?.length == 0) {
        checkData = 1;
    }

    const handleClick = (e) => {
        setIsTypingName(true);
        if (name.length > 0 && name.length < 21) {
            setDouble(true);
            const values = {
                name: name,
                gender: gender,
                birthday: dataDate,
            };
            if (!index_card) {
                dataMember.push(values);
            } else {
                dataMember[index_card] = values;
            }
            const params = {
                data: (checkData == 1 && index_card != 0) ? dataMember : dataMember.filter((item, index) => index !== 0),
                account_id: account_id,
                security_key: security_key,
                gender: index_card == 0 ? gender : genderchange?.length !== 0 ? genderchange : user.gender,
                birthday: index_card == 0 ? dataDate : birthchange?.length !== 0 ? birthchange : user.birthday,
            };
            localStorage.setItem("genderchange", params.gender);
            localStorage.setItem("birthchange", params.birthday);
            ListMembers.postDataMember(
                params,
                (res) => {
                    // setInfoMember([...res?.data]);
                    if (index_card === "0") {
                        updateDatachart();
                        localStorage.setItem("isCheckBirth", new Date());
                    }
                    history.push(`/add-member?account_id=${account_id}`);
                },
                () => {
                    setOpen(true);
                }
            );
        }
    };

    const handleClose = () => {
        setOpen(false);
        setDouble(false);
    };

    return (
        <div className="submit-information">
            <Button
                variant="contained"
                component="span"
                className="button-sm"
                disabled={double}
                onClick={(e) => {
                    handleClick();
                    e.preventDefault();
                }}
            >
                <p>{stringJp.label_button_submit}</p>
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="dialog-create-ok"
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title-create">{"例外エラーが発生しました。"}</DialogTitle>
                <hr style={{ margin: 0 }} />
                <DialogActions className="dialog-actions-create">
                    <Button onClick={handleClose} className="button-ok">
                        <p>{stringJp.label_button_submit_dialog}</p>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SubmitInfomation;
